@if (toasts().length) {
  <div class="qpt__stack" role="status" aria-live="polite">
    @for (toast of toasts(); track toast.id) {
      <div class="qpt__card">
        <p class="qpt__title">Agregando <span class="qpt__product-name">{{ toast.productName }}</span> a tu carrito</p>
        <div class="qpt__bar">
          <div class="qpt__bar-fill" [style.width.%]="toast.progressPercent"></div>
        </div>
        <p class="qpt__step">{{ toast.currentStepLabel }}</p>
      </div>
    }
  </div>
}
